export const setFlashMessage = (flashMessage) => {
    return {
        type: 'SET_FLASH_MESSAGE',
        flashMessage
    }
}

export const dismissFlashMessage = () => {
    return setFlashMessage(undefined)
}


// WEBPACK FOOTER //
// ./src/components/FlashMessage/FlashMessageActions.js